import { render, staticRenderFns } from "./MyPaymentsTable.vue?vue&type=template&id=687fe09e&scoped=true"
import script from "./MyPaymentsTable.vue?vue&type=script&lang=js"
export * from "./MyPaymentsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687fe09e",
  null
  
)

export default component.exports